enum EUserProvider {
  MALE_APPLICATION = 'MALE_APPLICATION',
  MANAGEMENT_APPLICATION = 'MANAGEMENT_APPLICATION',
}

enum ESystemMobile {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  OTHER = 'OTHER',
}

enum EContentSectionType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
}


enum EUrlButtonType {
  IMAGE_URL = 'imageUrl',
  VIDEO_URL = 'videoUrl',
}

export { EUserProvider, ESystemMobile, EUrlButtonType, EContentSectionType };
